import {Punto} from "./Punto";

export class Marcador {
  punto: Punto;
  popup: string | null;
  id: string;
  draggable = false;
  autoPan = false;
  autoPanSpeed: number | undefined;
  marcadorLeaflet: any;

  constructor(punto: Punto, popup: string | null) {
    this.punto = punto;
    this.popup = popup;
    this.id = new Date().getTime() + "";
  }

  public static generarMarcadorSimple(punto: Punto) {
    return new Marcador(punto, null);
  }

  public static generarMarcadorConPopUp(punto: Punto, textoPopup: string) {
    return new Marcador(punto, textoPopup);
  }

  public static generarMarcadorArrastrable(punto: Punto) {
    let m = new Marcador(punto, null);
    m.draggable = true;
    m.autoPan = true;
    m.autoPanSpeed = 10;
    return m;
  }

  public static generaJsonMarcador(punto: Punto) {
    return {
      type: 'Feature' as const,
      properties: {
        popupContent: `${punto.longitud}, ${punto.latitud}`,
        draggable: true
      },
      geometry: {
        type: 'Point' as const,
        coordinates: [punto.longitud, punto.latitud]
      }
    };
  }

  public getOpcionesMarcadorParaLeafletjs() {
    let opciones = {
      draggable: this.draggable,
      autoPan: this.autoPan,
      autoPanSpeed: this.autoPanSpeed
    }
    return opciones;
  }
}
